var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 3.67594C31.1522 3.02958 30.7992 2.4444 30.312 1.98261C29.8111 1.50661 29.1971 1.16612 28.528 0.993272C26.024 0.333272 15.992 0.333272 15.992 0.333272C11.8098 0.285689 7.6286 0.494971 3.47203 0.959938C2.80295 1.14556 2.19011 1.49365 1.68803 1.97327C1.1947 2.44794 0.837363 3.03327 0.650696 3.67461C0.202287 6.09026 -0.0155812 8.54306 2.94539e-05 10.9999C-0.0159705 13.4546 0.201363 15.9066 0.650696 18.3253C0.833363 18.9639 1.18936 19.5466 1.68403 20.0173C2.1787 20.4879 2.7947 20.8279 3.47203 21.0079C6.00936 21.6666 15.992 21.6666 15.992 21.6666C20.1796 21.7143 24.3661 21.505 28.528 21.0399C29.1971 20.8671 29.8111 20.5266 30.312 20.0506C30.799 19.5889 31.1516 19.0036 31.332 18.3573C31.7921 15.9425 32.0159 13.4887 32 11.0306C32.0346 8.56208 31.8112 6.09669 31.3334 3.67461V3.67594ZM12.8027 15.5653V6.43594L21.1494 11.0013L12.8027 15.5653Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8f80f30c8be3848c059adf4ba2d9863c.svg";
export { ForwardRef as ReactComponent };